exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".sk-wordpress>div{width:27px;height:27px;background-color:currentColor;display:inline-block;border-radius:27px;position:relative;-webkit-animation:sk-inner-circle 1s linear infinite;animation:sk-inner-circle 1s linear infinite}.sk-wordpress>div:after{content:\"\";display:block;background-color:#fff;width:8px;height:8px;position:absolute;border-radius:8px;top:5px;left:5px}@-webkit-keyframes sk-inner-circle{0%{-webkit-transform:rotate(0)}to{-webkit-transform:rotate(1turn)}}@keyframes sk-inner-circle{0%{transform:rotate(0);-webkit-transform:rotate(0)}to{transform:rotate(1turn);-webkit-transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-spinkit/css/wordpress.css
// module id = 776
// module chunks = 0